module.exports = __webpack_public_path__ + "media/application/images/video-play-btn-c6c6c94a915f70e58265df214df0d52f.svg";